import axios from 'axios'

export const getMyOffices = () => {
  return axios.get('/personnel-management/my-offices')
}

export const getMyOfficesDebug = (debugUserID) => {
  return axios.get('personnel-management/debug/my-offices', { params: { debugUserId: debugUserID } })
}

export const getLoanProductionDataForOffice = async ({ id, period }) => {
  return axios.get(`/leaderboard/rankingByOffice?officeId=${id}&year=${period}`, {
    transformResponse: [
      (res) => {
        const resJson = JSON.parse(res)
        resJson.data.period = period || new Date().getFullYear()
        return resJson
      },
    ],
  })
}

export const getLoanProductionPeriods = async () => {
  return axios.get(`/leaderboard/periods`)
}

export const getUserById = ({ id }) => {
  return axios.get(`/personnel-management/user/${id}`)
}

export const saveOfficeDetails = ({ id, officeDetails }) => {
  return axios.put(`/personnel-management/office/${id}`, {
    ...officeDetails,
  })
}

export const postUser = ({ userDetails }) => {
  return axios.post(`/personnel-management/user`, {
    ...userDetails,
  })
}

export const putUser = ({ userId, userDetails }) => {
  return axios.put(`/personnel-management/user/${userId}`, {
    ...userDetails,
  })
}

export const accessibleTerminateUser = ({ user, userId, newSecondaryEmail }) => {
  return axios.post(`/personnel-management/user/accessible-termination/${userId}`, {
    ...user,
    newSecondaryEmail,
  })
}

export const deactivateUser = ({ userId }) => {
  return axios.post(`/personnel-management/user/deactivate/${userId}`, {})
}

export const requestDeactivationForUser = ({
  userId,
  mottoForwardEmail,
  loanToTransfer,
  terminationReasonLoPhaseTwo,
  terminationReasonLoPhaseTwoOther,
}) => {
  if (mottoForwardEmail) {
    return axios.post(`/personnel-management/user/accessible-termination/request/${userId}`, {
      newSecondaryEmail: mottoForwardEmail,
      loanToTransfer,
      terminationReasonLoPhaseTwo,
      terminationReasonLoPhaseTwoOther,
    })
  }

  return axios.post(`/personnel-management/user/deactivate/request/${userId}`, {
    loanToTransfer,
    terminationReasonLoPhaseTwo,
    terminationReasonLoPhaseTwoOther,
  })
}

export const getEmailOptions = ({ userDetails }) => {
  return axios.post('/user/email/options', { ...userDetails })
}

export const getMottoRoles = () => {
  return axios.get('/account')
}

export const getUserDropdownOptions = ({ options = ['timezone'] } = {}) => {
  const optionsUri = options.reduce((acc, curr) => acc + `&options[]=${curr}`, '')
  return axios.get('/system/dropdown-options?' + optionsUri)
}

export const updateProfilePhoto = ({ formData, userId }) => {
  return axios.post(`/personnel-management/update-profile-picture-user/${userId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
